import { Updater, AsyncState, loadingAsyncState } from 'widgets-for-react'
import { getEventOverviewItems } from './eventOverviewApi'
import { initialPaginationState, PaginationState } from '../pagination/paginationState'
import { filtersToQueryParams, NewsAndEventsFilters } from '../../utils/filtersToQueryParams'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export type EventOverviewState = {
  paginationState: PaginationState
  eventItemsState: AsyncState<NewsOrEvent[]>
}

export const initialEventOverviewState = (
  page: number,
  tags?: string[],
  department?: string,
  subDepartment?: string,
  specialist?: string,
  centrum?: string,
  subcentra?: string
): EventOverviewState => {
  const filters: NewsAndEventsFilters = {
    tags: tags,
    department: department,
    subDepartment: subDepartment,
    specialist: specialist,
    centrum: centrum,
    subcentra: subcentra
  }
  return {
    paginationState: initialPaginationState(`/api/v1/pages/events/count/filter?${filtersToQueryParams(filters)}`),
    eventItemsState: loadingAsyncState(() => getEventOverviewItems(filters, page)),
  }
}

export const eventOverviewStateUpdaters = {
  updateEventCountState:
    (updater: Updater<AsyncState<number>>) =>
    (currentState: EventOverviewState): EventOverviewState => ({
      ...currentState,
      paginationState: updater(currentState.paginationState),
    }),
  updateEventItemsState:
    (updater: Updater<AsyncState<NewsOrEvent[]>>) =>
    (currentState: EventOverviewState): EventOverviewState => ({
      ...currentState,
      eventItemsState: updater(currentState.eventItemsState),
    }),
}
